<!-- HERO -->
<!-- HERO -->
<section class="hero">
  <div class="container">
    <div class="badge">📊 Interested to know top SIPs for 2026?</div>

    <div class="grid two">
      <div>
        <h1>Build ₹1 Crore with a Monthly SIP of Just ₹10,000</h1>
        <p>
          Start a Mutual Fund SIP today and potentially grow ₹24 lakh into ~₹1 crore
          in 20 years through disciplined, long-term investing.
        </p>

        <div class="icons">
          <span>₹10,000 Monthly SIP</span>
          <span>Long-Term Wealth Creation</span>
          <span>Expert-Guided Planning</span>
          <span>Goal-Based Investing</span>
        </div>

        <p class="muted">
          Mutual Fund investments are subject to market risks.
          Past performance is not indicative of future returns.
        </p>
      </div>

      <div class="card" *ngIf="!isThanksVisible" id="talktotus">
        <h3>Start Your ₹1 Crore SIP Journey Today – Talk to Us</h3>

        <form>
          <input type="text" autocomplete="off" id="name" name="name" [(ngModel)]="name" class="form-control"
            (blur)="removeErrorMsg('name')" placeholder="Please enter your full name"
            maxlength="40" 
            inputmode="text" oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');"
            (keydown)="alphaOnly($event)" [readOnly]="isOtpVisible">
            <div class="errormsg" *ngIf="nameValidateMessage == 'lengthError'">
              Invalid full name
          </div>
          <div class="errormsg" *ngIf="nameValidateMessage == 'required'">
              Full name is mandatory
          </div>

          <input type="text" (keydown.space)="$event.preventDefault();" autocomplete="off" id="mobile"
              name="mobile" [(ngModel)]="mobile" class="form-control"
              placeholder="Enter Your mobile number" minlength="10" maxlength="10"
              pattern="[6789][0-9]{9}" (blur)="removeErrorMsg('mobile')"
              inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
              (keypress)="numbersOnly($event)" [readOnly]="isOtpVisible">
          <div class="errormsg" *ngIf="mobileValidateMessage == 'lengthError'">
              10 digit mobile number is mandatory
          </div>
          <div class="errormsg" *ngIf="mobileValidateMessage == 'invalid'">
              Invalid mobile number
          </div>
          <div class="errormsg" *ngIf="mobileValidateMessage == 'required'">
              Mobile number is mandatory
          </div>

          <select class="selected-item  form-control" (blur)="removeErrorMsg('city')"
              [(ngModel)]="cityModel" name="city"
              (ngModelChange)="ValidateCity()" #city>
              <option selected disabled value="">Select City/District</option>
              <option *ngFor="let city of cityList;" [value]="city['name']+'-'+city['Id']">
                {{city['name']}}
              </option>
          </select>
          <div class="errormsg" *ngIf="cityMesaage == 'required'">
              City selection is mandatory
          </div>

          <select name="sipVal" (blur)="removeErrorMsg('sipval')" [(ngModel)]="sipVal">
            <option value="">SIP Amount</option>
            <option value="5,000 - 10,000">5,000 - 10,000</option>
            <option value="10,000 - 25,000">10,000 - 25,000</option>
            <option value="25,000 - 50,000">25,000 - 50,000</option>
            <option value="More Than 50,000">More Than 50,000</option>
          </select>
          <div class="errormsg" *ngIf="sipValValidateMessage == 'required'">
            This field is mandatory
        </div>

          <ng-container *ngIf="isOtpVisible">
            <input type="text" autocomplete="off"
                (keydown.space)="$event.preventDefault();" (keyup)="removeErrorMsg('otp')"
                id="otp" name="otp" [(ngModel)]="userOTP" class="form-control" maxlength="6"
                placeholder="Enter OTP" (keypress)="numberspincode($event)" (input)="checkOtpLength()" [readOnly]="otpVerified">
                <div class="successmsg" *ngIf='otpVerified'>
                  OTP verified
                </div>
                <div class="errormsg" *ngIf='otpError'>
                  Invalid OTP
                </div>
                <div class="errormsg" *ngIf="otpValidateMessage == 'required'">
                  Please enter OTP to continue.
                </div>
                <div class="errormsg" *ngIf="otpValidateMessage == 'lengthError'">Invalid OTP
                </div>
                <span *ngIf="isTimer">Didn't recieve OTP? Resend in <strong
                  style="font-size:17px;">{{timeleft}} </strong>seconds</span>
                <a class="resendotp" href="javascript:void(0)" *ngIf="isResend"
                    (click)="resendOTP()">Resend OTP</a>
        </ng-container>
          <button type="button" class="btn" style="width:100%" (click)="PostData()">
            Submit
          </button>

          <p class="muted">
            Trusted by millions of investors • AMFI-registered advisors
          </p>
        </form>
      </div>
      <div class="card card-body success-card" *ngIf="isThanksVisible">
        <div class="success-tick">
            <h2 style="color: black;">Thank you!</h2>
        </div>
        <h6>A member of our care team will get in touch with you shortly.</h6>
      </div>
    </div>
  </div>
</section>

  
  <!-- HOW IT WORKS -->
  <section class="section">
    <div class="container">
      <h2>How It Works</h2>
      <div class="grid" style="grid-template-columns:repeat(auto-fit,minmax(200px,1fr))">
        <div class="card">📝 <strong>Share Details</strong><p class="muted">Tell us about your goals</p></div>
        <div class="card">📞 <strong>RM Connect</strong><p class="muted">Dedicated advisor calls you</p></div>
        <div class="card">🎯 <strong>Goal Mapping</strong><p class="muted">SIPs aligned to life goals</p></div>
        <div class="card">📈 <strong>Ongoing Review</strong><p class="muted">Monitor & rebalance regularly</p></div>
      </div>
    </div>
  </section>
  
  <!-- CALCULATOR -->
  <section id="calculator">
    <div class="container grid two">
      <div>
        <h2>SIP Calculator (Illustrative)</h2>

        <div class="card">
          <label>Monthly SIP Amount (₹)</label>
          <input type="number" [(ngModel)]="sip" />

          <label>Investment Duration (Years)</label>
          <input type="number" [(ngModel)]="years" />

          <label>
            Expected Annual Return (%) 
            <span class="muted">(Assumed)</span>
          </label>
          <input type="number" [(ngModel)]="rate" />

          <div style="display:flex;align-items:center;gap:10px;margin:12px 0">
            <input
              type="checkbox"
              [(ngModel)]="stepUp"
              style="width:20px;height:20px;accent-color:#c4161c"
            />
            <label style="font-weight:600;cursor:pointer">
              Enable 10% Annual Step-Up SIP
            </label>
          </div>

          <button class="btn" style="width:100%" (click)="calc()">
            Calculate
          </button>

          <div *ngIf="showResult" style="margin-top:16px">
            <p>
              <strong>Total Invested:</strong>
              ₹{{ invested | number }}
            </p>
            <p>
              <strong>Estimated Corpus:</strong>
              ₹{{ corpus | number }}
            </p>
            <p class="muted">Illustrative only. Actual returns may vary.</p>
            <button class="btn" (click)="scrollToForm()">Talk to Us</button>
          </div>
        </div>
      </div>

      <div>
        <h3>Why Use This Calculator?</h3>
        <ul>
          <li>Visualise long-term wealth</li>
          <li>Compare SIP vs Step-Up SIP</li>
          <li>Convert numbers into a real plan</li>
        </ul>
      </div>
    </div>
  </section>

  
  <!-- PROOF -->
  <section class="section">
    <div class="container">
      <h2>Can ₹10,000 a Month Really Become ₹1 Crore?</h2>
      <p><strong>Yes — with time, discipline, and staying invested.</strong></p>
      <p>₹10,000/month for 20 years at ~12% assumed returns:</p>
      <ul>
        <li><strong>Total Invested:</strong> ₹24,00,000</li>
        <li><strong>Potential Corpus:</strong> ~₹99,90,000</li>
        <li><strong>Wealth Gain:</strong> ~₹75,90,000</li>
      </ul>
      <p><strong>👉 Staying invested creates 4x+ growth.</strong></p>
  
      <p class="muted">The real magic of compounding happens in the later years. The longer you stay invested, the faster your money starts growing — this is why patience is critical in SIP investing.</p>
  
      <table>
        <tr><th>Years</th><th>Invested</th><th>Approx Value</th></tr>
        <tr><td>5</td><td>₹6,00,000</td><td>₹8.2L</td></tr>
        <tr><td>10</td><td>₹12,00,000</td><td>₹23.2L</td></tr>
        <tr><td>15</td><td>₹18,00,000</td><td>₹49.6L</td></tr>
        <tr><td>20</td><td>₹24,00,000</td><td>~₹1 Cr</td></tr>
      </table>
  
      <div style="margin-top:24px;text-align:center">
        <button class="btn" (click)="scrollToCalculator()">
          Use Our Crorepati SIP Calculator
        </button>      </div>
    </div>
  </section>
  
  <!-- BAJAJ CAPITAL -->
  <section class="section">
    <div class="container">
  
      <div class="card" style="margin-bottom:32px">
        <h2>Examples of Top Performing Mutual Funds</h2>
        <p>There are multiple mutual fund categories across equity and hybrid segments. Choosing the right categories correctly and staying invested with discipline over the long term is the key to wealth creation.</p>
  
        <ul>
          <li>Large Cap Equity Funds – Stability with long-term growth potential</li>
          <li>Flexi Cap Funds – Dynamic allocation across market caps</li>
          <li>Mid & Small Cap Funds – Higher growth potential with higher volatility</li>
          <li>Hybrid Funds – Balanced mix of equity and debt</li>
          <li>Index Funds – Low-cost participation in market growth</li>
        </ul>
    
        <button class="btn" style="margin-top:12px" (click)="scrollToForm()">Discuss with Our Relationship Manager</button>
  <br><br>
        <p class="muted">Disclaimer: Mutual fund categories and illustrations shown are for educational purposes only. This is not a recommendation. Past performance is not indicative of future returns.</p>
      </div>
  
      <div class="brand">
        <h2>Why Bajaj Capital?</h2>
        <p>With decades of experience, Bajaj Capital helps investors choose the right mutual funds, align SIPs to life goals, and stay invested with confidence through market cycles.</p>
  
        <div style="margin-top:20px;display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:16px">
          <div><strong>60+ Years</strong><br/><span class="muted">of Experience</span></div>
          <div><strong>₹20,000+ Cr</strong><br/><span class="muted">Assets under Management</span></div>
          <div><strong>41+ Lakh</strong><br/><span class="muted">Investors</span></div>
          <div><strong>300+</strong><br/><span class="muted">Branches across 100 cities</span></div>
          
        </div>
      </div>
    </div>
  </section>
  
  <!-- FAQs -->
  <section class="section">
    <div class="container">
      <h2>Mutual Fund SIP – Frequently Asked Questions</h2>
  
      <div class="card">
        <h3>1. What is a Mutual Fund SIP?</h3>
        <p>A Systematic Investment Plan (SIP) allows you to invest a fixed amount at regular intervals in mutual funds. SIPs help inculcate financial discipline and benefit from long-term compounding.</p>
      </div>
  
      <div class="card">
        <h3>2. Can ₹10,000 SIP really grow into ₹1 Crore?</h3>
        <p>Yes, with a long-term investment horizon of around 20 years and assumed annual returns of ~12%, a ₹10,000 monthly SIP can potentially grow to nearly ₹1 crore. Actual returns may vary.</p>
      </div>
  
      <div class="card">
        <h3>3. What is the ideal duration for SIP investments?</h3>
        <p>SIPs work best over the long term. A minimum horizon of 10–15 years is recommended, especially for goals like wealth creation, children’s education, or retirement.</p>
      </div>
  
      <div class="card">
        <h3>4. Is SIP better than a lumpsum investment?</h3>
        <p>SIPs reduce market timing risk by averaging purchase costs over time. Lumpsum investments may be suitable when markets are attractive or surplus funds are available. Many investors use a combination of both.</p>
      </div>
  
      <div class="card">
        <h3>5. What is a Step-Up SIP?</h3>
        <p>A Step-Up SIP allows you to increase your SIP amount periodically (usually annually) as your income grows. This helps you reach financial goals faster without straining your current budget.</p>
      </div>
  
      <div class="card">
        <h3>6. Are SIP returns guaranteed?</h3>
        <p>No. Mutual fund SIP returns are market-linked and not guaranteed. However, long-term investing has historically helped investors manage volatility and generate wealth over time.</p>
      </div>
  
      <div class="card">
        <h3>7. Can I stop or modify my SIP anytime?</h3>
        <p>Yes. SIPs are flexible—you can pause, stop, increase, or decrease your SIP amount at any time based on your financial situation.</p>
      </div>
  
      <div class="card">
        <h3>8. How does Bajaj Capital help with SIP investments?</h3>
        <p>Bajaj Capital provides expert guidance in selecting suitable mutual funds, aligning SIPs with life goals, periodic portfolio reviews, and ongoing investment support.</p>
      </div>
  
    </div>
  </section>
  
  <!-- PORTFOLIO REVIEW -->
  <section class="section">
    <div class="container">
      <div class="grid two">
        <div>
          <h2>Want to Check How Your Portfolio Is Performing?</h2>
          <p>Already investing but unsure if your portfolio is on track? Speak with our experts for a comprehensive review and guidance aligned to your financial goals.</p>
        </div>
        <div class="card" *ngIf="!isThanksVisible2">
          <h3>Talk to Us</h3>
          <form>
            <input type="text" autocomplete="off" id="name2" name="name2" [(ngModel)]="name2" class="form-control"
              (blur)="removeErrorMsg2('name2')" placeholder="Please enter your full name"
              maxlength="40" 
              inputmode="text" oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');"
              (keydown)="alphaOnly($event)" [readOnly]="isOtpVisible2">
              <div class="errormsg" *ngIf="nameValidateMessage2 == 'lengthError'">
                Invalid full name
            </div>
            <div class="errormsg" *ngIf="nameValidateMessage2 == 'required'">
                Full name is mandatory
            </div>
  
            <input type="text" (keydown.space)="$event.preventDefault();" autocomplete="off" id="mobile2"
                name="mobile2" [(ngModel)]="mobile2" class="form-control"
                placeholder="Enter Your mobile number" minlength="10" maxlength="10"
                pattern="[6789][0-9]{9}" (blur)="removeErrorMsg2('mobile2')"
                inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                (keypress)="numbersOnly($event)" [readOnly]="isOtpVisible2">
            <div class="errormsg" *ngIf="mobileValidateMessage2 == 'lengthError'">
                10 digit mobile number is mandatory
            </div>
            <div class="errormsg" *ngIf="mobileValidateMessage2 == 'invalid'">
                Invalid mobile number
            </div>
            <div class="errormsg" *ngIf="mobileValidateMessage2 == 'required'">
                Mobile number is mandatory
            </div>
  
            <select class="selected-item  form-control" (blur)="removeErrorMsg2('city2')"
                [(ngModel)]="cityModel2" name="city2"
                (ngModelChange)="ValidateCity2()" #city2>
                <option selected disabled value="">Select City/District</option>
                <option *ngFor="let city2 of cityList;" [value]="city2['name']+'-'+city2['Id']">
                  {{city2['name']}}
                </option>
            </select>
            <div class="errormsg" *ngIf="cityMesaage2 == 'required'">
                City selection is mandatory
            </div>
  
            <select name="sipVal2" (blur)="removeErrorMsg2('sipval2')" [(ngModel)]="sipVal2">
              <option value="">SIP Amount</option>
              <option value="5,000 - 10,000">5,000 - 10,000</option>
              <option value="10,000 - 25,000">10,000 - 25,000</option>
              <option value="25,000 - 50,000">25,000 - 50,000</option>
              <option value="More Than 50,000">More Than 50,000</option>
            </select>
            <div class="errormsg" *ngIf="sipValValidateMessage2 == 'required'">
              This field is mandatory
          </div>
  
            <ng-container *ngIf="isOtpVisible2">
              <input type="text" autocomplete="off"
                  (keydown.space)="$event.preventDefault();" (keyup)="removeErrorMsg2('otp2')"
                  id="otp2" name="otp2" [(ngModel)]="userOTP2" class="form-control" maxlength="6"
                  placeholder="Enter OTP" (keypress)="numberspincode($event)" (input)="checkOtpLength2()" [readOnly]="otpVerified2">
                  <div class="successmsg" *ngIf='otpVerified2'>
                    OTP verified
                  </div>
                  <div class="errormsg" *ngIf='otpError2'>
                    Invalid OTP
                  </div>
                  <div class="errormsg" *ngIf="otpValidateMessage2 == 'required'">
                    Please enter OTP to continue.
                  </div>
                  <div class="errormsg" *ngIf="otpValidateMessage2 == 'lengthError'">Invalid OTP
                  </div>
                  <span *ngIf="isTimer2">Didn't recieve OTP? Resend in <strong
                    style="font-size:17px;">{{timeleft2}} </strong>seconds</span>
                  <a class="resendotp" href="javascript:void(0)" *ngIf="isResend2"
                      (click)="resendOTP2()">Resend OTP</a>
          </ng-container>
            <button type="button" class="btn" style="width:100%" (click)="PostData2()">
              Submit
            </button>
          </form>
        </div>
        <div class="card card-body success-card" *ngIf="isThanksVisible2">
          <div class="success-tick">
              <h2 style="color: black;">Thank you!</h2>
          </div>
          <h6>A member of our care team will get in touch with you shortly.</h6>
        </div>
      </div>
    </div>
  </section>
  
  <footer>
    Bajaj Capital Limited – AMFI Registered Mutual Fund Distributor.<br/>
    Mutual Fund investments are subject to market risks. Please read all scheme-related documents carefully.
  </footer>